import angular from "angular";

import ServiceProviderSettingsModuleRouting from "./service-provider-settings.module.routing";

export default angular
  .module("vt-service-provider-settings", [])
  .config(ServiceProviderSettingsModuleRouting);
